import { render, staticRenderFns } from "./amenity.vue?vue&type=template&id=447b4084"
import script from "./amenity.vue?vue&type=script&lang=js"
export * from "./amenity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports